import {
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { Fragment, useState } from 'react';
import { PmiBodyTableCell } from 'shell/components/shared/table-custom/body';
import { PmiHeadTableCell } from 'shell/components/shared/table-custom/head';
import { PmiTableRow } from 'shell/components/shared/table/row';
import DeleteIcon from '@mui/icons-material/Delete';
import { Anomaly } from 'shell/view-models/anomaly';
import { Edit } from '@mui/icons-material';

interface AnomaliesTableProps {
  anomalies: Anomaly[];
  disabled: boolean;
  onDelete: (anomaly: Anomaly) => void;
  onEdit: (anomaly: Anomaly) => void;
  visibleOperator?: boolean;
}
const AnomaliesTable = ({
  anomalies = [],
  disabled,
  onDelete,
  onEdit,
  visibleOperator = true,
}: AnomaliesTableProps): React.ReactElement => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const rowsPerPageOptions = [5, 10, 20, 50];

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  return (
    <Fragment>
      <TableContainer>
        <Table sx={{ minWidth: 900 }} size="medium" stickyHeader aria-label="lista anomalie">
          <TableHead>
            <TableRow>
              <PmiHeadTableCell>Codice</PmiHeadTableCell>
              <PmiHeadTableCell>Descrizione</PmiHeadTableCell>
              <PmiHeadTableCell>Data inserimento</PmiHeadTableCell>
              {visibleOperator ? (
                <PmiHeadTableCell>Operatore inserimento</PmiHeadTableCell>
              ) : undefined}
              <PmiHeadTableCell>Data cancellazione</PmiHeadTableCell>
              {visibleOperator ? (
                <PmiHeadTableCell>Operatore cancellazione</PmiHeadTableCell>
              ) : undefined}
              <PmiHeadTableCell>Azioni</PmiHeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {anomalies.slice(startIndex, endIndex).map((anomaly, i) => (
              <PmiTableRow key={i.toString()}>
                <PmiBodyTableCell id={`${i}-code`} scope="row">
                  {anomaly.code}
                </PmiBodyTableCell>
                <PmiBodyTableCell id={`${i}-description`} scope="row">
                  {anomaly.description}
                </PmiBodyTableCell>
                <PmiBodyTableCell id={`${i}-insert-date`} scope="row">
                  {anomaly.insertDate ? anomaly.insertDate.toFormat('dd/MM/yyyy') : ''}
                </PmiBodyTableCell>
                {visibleOperator ? (
                  <PmiBodyTableCell id={`${i}-insert-operator`} scope="row">
                    {anomaly.insertOperator || ''}
                  </PmiBodyTableCell>
                ) : undefined}
                <PmiBodyTableCell id={`${i}-cancel-date`} scope="row">
                  {anomaly.cancelDate ? anomaly.cancelDate.toFormat('dd/MM/yyyy') : ''}
                </PmiBodyTableCell>
                {visibleOperator ? (
                  <PmiBodyTableCell id={`${i}-cancel-operator`} scope="row">
                    {anomaly.cancelOperator || ''}
                  </PmiBodyTableCell>
                ) : undefined}
                <PmiBodyTableCell id={`${i}-delete-action`} scope="row">
                  <div className="pmi-d-flex">
                    <IconButton
                      color="primary"
                      aria-label="edit anomaly"
                      component="span"
                      onClick={() => onEdit(anomaly)}
                      disabled={disabled}
                    >
                      <Edit />
                    </IconButton>
                    {!anomaly.cancelDate ? (
                      <IconButton
                        color="error"
                        aria-label="remove anomaly"
                        component="span"
                        onClick={() => onDelete(anomaly)}
                        disabled={disabled}
                      >
                        <DeleteIcon />
                      </IconButton>
                    ) : undefined}
                  </div>
                </PmiBodyTableCell>
              </PmiTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        labelRowsPerPage="Righe per pagina:"
        count={anomalies.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event: unknown, newPage: number) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
        }}
      />
    </Fragment>
  );
};

AnomaliesTable.displayName = 'Tabella anomalie';

export default AnomaliesTable;
